/* family-mortgage page */
import vueUIInitiator from './modules/vue-ui-initiator';
import StepsSlider from './vue-components/pages/StepsSwitcher';
import showMore from './pages/show-more';
import dropdownButton from './pages/ui/button-dropdown';

vueUIInitiator('js-steps-switcher', StepsSlider, 'steps-switcher');

document.addEventListener('DOMContentLoaded', () => {
    dropdownButton();
    showMore();
});
